export default __webpack_public_path__ + "static/media/banner.a15076ea.jpg";